/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Preset_Manager_Import_Results_TitleInputs */



/**
* | output |
* | --- |
* | "Import Results" |
*
* @param {Preset_Manager_Import_Results_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const preset_manager_import_results_title = /** @type {((inputs?: Preset_Manager_Import_Results_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Preset_Manager_Import_Results_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Resultats de l'importation")
	if (locale === "de") return /** @type {LocalizedString} */ ("Importergebnisse")
	if (locale === "it") return /** @type {LocalizedString} */ ("Importa risultati")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Результаты импорта")
	if (locale === "es") return /** @type {LocalizedString} */ ("Importar resultados")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("导入结果")
	if (locale === "ja") return /** @type {LocalizedString} */ ("インポート結果")
	if (locale === "hi") return /** @type {LocalizedString} */ ("परिणाम आयात करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Resultados da Importação")
	return /** @type {LocalizedString} */ ("Import Results")
});